/**
 * Uploaded-audio player chrome for posts / comments / chats.
 *
 * Default `timeline` for file attachments. Empty peaks already force timeline
 * via `resolveEffectiveVoicePlayerVariant`; the default makes that explicit.
 * Keep this the single source of truth — do not hardcode variants at call sites.
 */
import type { UploadedAudioPlayerVariant } from '../types/voice.types'

export type { UploadedAudioPlayerVariant } from '../types/voice.types'

export const UPLOADED_AUDIO_PLAYER_VARIANT: UploadedAudioPlayerVariant = 'timeline'

/** Resolve playback chrome for recorded vs uploaded audio. */
export function resolveVoicePlayerVariant(isUploaded: boolean): UploadedAudioPlayerVariant {
  return isUploaded ? UPLOADED_AUDIO_PLAYER_VARIANT : 'waveform'
}

/**
 * Prefer the requested variant, but fall back to timeline when waveform peaks
 * are missing so the playbox never renders an empty bar canvas.
 */
export function resolveEffectiveVoicePlayerVariant(
  variant: UploadedAudioPlayerVariant,
  waveformPeaks: readonly number[] | null | undefined
): UploadedAudioPlayerVariant {
  return variant === 'waveform' && waveformPeaks?.length ? 'waveform' : 'timeline'
}
